import type { ApplyStyleObject } from '@types'

export const variables: ApplyStyleObject = {
  ':root': `
    [--anc-inset-shadow]-[0_0_#0000]
    [--anc-inset-ring-shadow]-[0_0_#0000]
    [--anc-shadow]-[0_0_#0000]
    [--anc-ring-shadow]-[0_0_#0000]
    [--anc-ring-offset-shadow]-[0_0_#0000]
    [--anc-ring-offset-width]-0px
    [--anc-ring-inset]-[_]
    [--anc-ring-offset-color]-#fff
  `
}
